// src/pages/CertificationsPage.js
import React from 'react';
import useSEO from '../hooks/useSEO';

const CertificationsPage = () => {
  useSEO();

  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>Certificações</h1>
      <p>Página em desenvolvimento - Por favor aguarde.</p>
    </div>
  );
};

export default CertificationsPage;
